import React from 'react';
import nammaVideo from '../../assets/namma-video.mp4';
import iskconVideo from '../../assets/iskcon-video.mp4';
import panchamVideo from '../../assets/Himmat Ki Dhvani.mp4';

const SPONSORS_DATA = [
  {
    id: 1,
    sponsorName: "Namma - Flavours of Tulunad",
    eventName: "Himmat Ka Swaad",
    description: "Namma supported our cause by hosting a special lunch dedicated to honoring our Himmatwaalis. Through the warmth of their hospitality, they helped us celebrate courage, community, and gratitude, providing these hardworking women with a day of joy and respect.",
    mediaType: "video", // use 'video' or 'image'
    mediaSrc: nammaVideo,
  },
  {
    id: 2,
    sponsorName: "ISKCON Juhu, Mumbai",
    eventName: "Himmat Meri Pooja",
    description: "ISKCON graciously presented a deeply spiritual evening for the women. The event featured an uplifting lecture on courage drawn from the Bhagavad Gita, followed by Aarti and Prasadam. It was a profound recognition of the divine strength within every Himmatwaali.",
    mediaType: "video",
    mediaSrc: iskconVideo,
  },
  {
    id: 3,
    sponsorName: "Pancham Sound Studio",
    eventName: "Himmat Ki Dhvani",
    description: "Pancham Sound Studio beautifully recognized the courage of Himmatwaali Anita by providing her with a professional song recording session. This unique initiative gave a voice to her inner strength, proving that courage has its own beautiful melody.",
    mediaType: "video",
    mediaSrc: panchamVideo,
  }
];



const Sponsors = () => {
  return (
    <section className="bg-bg-light px-6 py-14 md:px-12">
      <div className="mx-auto max-w-6xl">
        
        {/* Section Header */}
        <div className="mx-auto mb-10 max-w-3xl text-center md:mb-12">
          <h2 className="mb-5 text-3xl font-bold uppercase text-accent md:text-4xl">
            Collaborations of Courage
          </h2>
          <p className="text-base leading-relaxed text-gray-700 md:text-lg">
            We are deeply grateful to the organizations that have joined hands with the 
            Drishtikon Himmatwaali Mission. Together, we are creating spaces to celebrate, 
            uplift, and honor the extraordinary women around us.
          </p>
        </div>

        {/* Dynamic Layout Container */}
        <div className="space-y-16 md:space-y-24">
          
          {SPONSORS_DATA.map((sponsor, index) => {
            const isReversed = index % 2 !== 0;

            return (
              <div key={sponsor.id} className="grid items-center gap-10 md:grid-cols-2 md:gap-14">
                
                {/* Media Column - Centered */}
                <div className={`flex w-full justify-center ${isReversed ? 'order-1 md:order-2' : ''}`}>
                  {sponsor.mediaType === 'video' ? (
                    <video 
                      src={sponsor.mediaSrc}
                      className="h-auto w-full max-w-[300px] rounded-3xl object-contain shadow-xl ring-1 ring-black/10 sm:max-w-[360px] md:max-h-[560px] md:max-w-[420px]" 
                      controls 
                      playsInline 
                      preload="metadata"
                    ></video>
                  ) : (
                    <img 
                      alt={`${sponsor.eventName} at ${sponsor.sponsorName}`}
                      className="h-auto max-h-[420px] w-full max-w-[300px] rounded-3xl object-contain shadow-xl ring-1 ring-black/10 sm:max-w-[360px] md:max-h-[560px] md:max-w-[420px]" 
                      src={sponsor.mediaSrc} 
                    />
                  )}
                </div>

                {/* Text Column */}
                <div className={`flex flex-col justify-center ${isReversed ? 'order-2 md:order-1' : ''}`}>
                  <div className="mb-3 flex items-center gap-3">
                    <span className="text-sm font-bold uppercase tracking-wider text-primary/70">
                      Collaboration {String(index + 1).padStart(2, '0')}
                    </span>
                    <span className="h-px flex-1 bg-gray-200" />
                  </div>
                  <span className="mb-2 inline-flex w-fit rounded-full bg-accent/10 px-3 py-1 text-sm font-bold uppercase tracking-wider text-accent">
                    {sponsor.sponsorName}
                  </span>
                  <h3 className="mb-4 text-2xl font-bold text-primary md:text-3xl">
                    {sponsor.eventName}
                  </h3>
                  <p className="text-base leading-relaxed text-gray-700 md:text-lg">
                    {sponsor.description}
                  </p>
                </div>
                
              </div>
            );
          })}

        </div>
      </div>
    </section>
  );
};

export default Sponsors;
